// Sentry must initialize before React renders.
import { Sentry } from './sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element missing');

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

function FallbackUI(): JSX.Element {
  return (
    <main className="min-h-screen bg-offwhite text-ink font-sans flex items-center justify-center px-6">
      <div className="max-w-xl w-full">
        <h1 className="text-3xl font-semibold tracking-tight text-navy">
          Something broke.
        </h1>
        <p className="mt-3 text-grey text-sm">
          The error has been reported. Reload to try again.
        </p>
      </div>
    </main>
  );
}
